import { render, staticRenderFns } from "./travelSpecsLogDetails.vue?vue&type=template&id=25a3937b&scoped=true&"
import script from "./travelSpecsLogDetails.vue?vue&type=script&lang=js&"
export * from "./travelSpecsLogDetails.vue?vue&type=script&lang=js&"
import style0 from "./travelSpecsLogDetails.vue?vue&type=style&index=0&id=25a3937b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3937b",
  null
  
)

export default component.exports